<div class="ipm-container mb-5">
    <div class="ipm-common-tab-section" >
        <div class="ipm-left-section">
            <div class="left-scroll-btn"><span class="pi pi-angle-left" (click)="scrollLeft()"></span></div>
            <div class="ipm-main-section" id="scrollContainer">
                <ng-container *ngFor="let headingObj of headingList">
                    <div class="ipm-tab-button">
                        <button class="ipm-left-panel tabLinks"  [class.active]="headingObj?.isSelected"
                            [class.error-border-section]="headingObj?.isShowError"
                            (click)="settingTab(headingObj?.id)">
                            <div class="d-flex gap-2 align-items-center">
                                {{headingObj.label}}
                                <i  class="fa fa-exclamation-triangle" *ngIf="headingObj?.isShowError"></i>
                            </div>
                            <div class="icon-section" *ngIf="headingObj?.isShowIcon">
                                  <p-progressSpinner ariaLabel="loading" styleClass="ipm-spinner-custom" *ngIf="headingObj.processUploading"
                                    [style]="{'height': '25px', 'margin-right': '5px'}"
                                    strokeWidth="4"
                                    animationDuration="3s"/>
                                <img class="rightIcon" priority [src]="headingObj?.icon" [alt]="headingObj?.key+'icon'" width="24"
                                    height="24">
                            </div>
                        </button>
                    </div>
                </ng-container>
            </div>
            <div class="right-scroll-btn"><span class="pi pi-angle-right" (click)="scrollRight()"></span></div>
            <ng-content select="[ipmTabSubHeader]"></ng-content>
        </div>
        <div class="ipm-tab-body-section">
            <!-- Optional content projected just below the tab menu (e.g. estimated impressions box) -->
            <ng-content select="[ipmTabBody]"></ng-content>
        </div>
    </div>
</div>
